import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const addTrustBeneficiaryFeatureKey = 'addTrustBeneficiary';

export interface AddTrustBeneficiaryState {
  addTrustBeneficiaryResponse: string | null;
  addTrustBeneficiaryFailure: Error | any;
}

export const initialState: AddTrustBeneficiaryState = {
  addTrustBeneficiaryResponse: null,
  addTrustBeneficiaryFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.addTrustBeneficiarySuccess, (state, action) => ({
    ...state,
    addTrustBeneficiaryResponse: action.response
  })),
  on(actions.addTrustBeneficiaryFailure, (state, action) => ({
    ...state,
    addTrustBeneficiaryFailure: action.error
  }))
);
